export default "__VITE_ASSET__DtRJOC5D__"